import { render, staticRenderFns } from "./ShiftsMainTable.vue?vue&type=template&id=7cb4ac0b&scoped=true&"
import script from "./ShiftsMainTable.vue?vue&type=script&lang=js&"
export * from "./ShiftsMainTable.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsMainTable.vue?vue&type=style&index=0&id=7cb4ac0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb4ac0b",
  null
  
)

export default component.exports